import 'bootstrap/dist/css/bootstrap.css';
import { cnpj as cnpjValidacao } from 'cpf-cnpj-validator';
import { ChangeEvent, useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { useLocation, useParams } from 'react-router-dom';
import { EnderecoDTO } from '../../../shared/dto/enderecoDTO';
import { PromotoraDTO } from '../../../shared/dto/promotoraDTO';
import { Matriz } from '../../../shared/model/matriz'; //
import { Originador } from '../../../shared/model/originador'; //
import Spinner from '../../../shared/spinner';
import { Button, Row, Col, Form } from 'react-bootstrap'; 
import MatrizService from '../../../services/matrizService'; //
import PromotoraService from '../../../services/promotoraService'; //
import ViaCepService from '../../../services/viaCepService';
import OriginadorService from '../../../services/originadorService'; //
import ParametrosService from '../../../services/parametrosService';
import CustomAlert from '../../../shared/customAlert';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import { NumericFormat } from 'react-number-format';
import { Regional } from '../../../shared/model/regional'; 
import { Comercial } from '../../../shared/model/comercial'; 
import RegionalService from '../../../services/regionalService';
import ComercialService from '../../../services/comercialService';
import DualListBox from '../../../shared/DualListBox';
import PromotoraDadosGestaoModal from './promotoraDadosGestaoModal';
import PromotoraDocumentacaoModal from './promotoraDocumentacaoModal';

const normalizarBooleano = (valor: any) => valor === true || valor === 1 || valor === '1' || valor === 'true';

interface ListItem {
  id: number | string;
  nome: string;
}

function PromotoraInclusaoAlteracao() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const location = useLocation();
  const { id } = location.state || {};
  const { tipo } = useParams();

  const [regionais, setRegionais] = useState<Regional[]>([]); 
  const [selectedRegionais, setSelectedRegionais] = useState<ListItem[]>([]); 
  //const isInitialMount = useRef(true);
  const [comerciais, setComerciais] = useState<Comercial[]>([]); 
  const [selectedComerciais, setSelectedComerciais] = useState<ListItem[]>([]); 
  const [showRegionalBox, setShowRegionalBox] = useState(false);
  const [showComercialBox, setShowComercialBox] = useState(false);
  const [matriz, setMatriz] = useState('');
  const [matrizes, setMatrizes] = useState<Matriz[]>([]);
  
  // --- Originador como secundário ---
  const [originador, setOriginador] = useState('');
  const [originadores, setOriginadores] = useState<Originador[]>([]);
  const [showOriginadorBox, setShowOriginadorBox] = useState(false); // Checkbox para habilitar originador

  const [nome, setNome] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [emails, setEmails] = useState('');
  const [representante, setRepresentante] = useState('');
  const [telefoneComercial, setTelefoneComercial] = useState('');
  const [telefoneCelular, setTelefoneCelular] = useState('');
  const [gerenteResponsavel, setGerenteResponsavel] = useState('');
  const [valorMeta, setValorMeta] = useState<number | string>(0);
  const [numeroMaximoConsultasDia, setNumeroMaximoConsultasDia] = useState<number | string>(0);

  // Endereço
  const [cep, setCep] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [localidade, setLocalidade] = useState('');
  const [uf, setUf] = useState('');

  // Configurações
  const [codigoExterno, setCodigoExterno] = useState('');
  const [promotoraAquisicao, setPromotoraAquisicao] = useState(false);

  // DADOS BANCÁRIOS (Necessários para CNAB 240) ---
  const [codigoBanco, setCodigoBanco] = useState(''); // Separado do nome
  const [nomeBanco, setNomeBanco] = useState('');     // Separado do código
  const [agencia, setAgencia] = useState('');
  const [conta, setConta] = useState('');
  const [digitoConta, setDigitoConta] = useState('');
  const [tipoConta, setTipoConta] = useState('CORRENTE'); // Default
  const [camaraCentralizadora, setCamaraCentralizadora] = useState('018'); // Default TED (STR)
  const [chavePix, setChavePix] = useState('');

  const [loading, setLoading] = useState(false);
  const [promotoraFluxoGestao, setPromotoraFluxoGestao] = useState<PromotoraDTO | null>(null);
  const [dadosGestaoOpen, setDadosGestaoOpen] = useState(false);
  const [documentacaoOpen, setDocumentacaoOpen] = useState(false);
  const [gestaoPromotoraAtiva, setGestaoPromotoraAtiva] = useState(false);

  const matrizService: MatrizService = new MatrizService();
  const promotoraService: PromotoraService = new PromotoraService();
  const viaCepService: ViaCepService = new ViaCepService();
  const originadorService: OriginadorService = new OriginadorService();
  const parametrosService: ParametrosService = new ParametrosService();

    // Dicionário de explicações para formas de pagamento
  const explicacoesPagamento: { [key: string]: string } = {
    '018': 'TED (STR): Transferência Eletrônica Disponível convencional. Utilize para contas de bancos diferentes. O crédito geralmente ocorre no mesmo dia se enviado até o horário de corte (17h).',
    '000': 'Mesmo Banco (CC): Crédito em Conta Corrente. Utilize SOMENTE quando o banco de origem (pagador) for o mesmo do banco de destino (favorecido). Processamento mais rápido e sem custos de TED.',
    '009': 'PIX: Pagamento Instantâneo. Obrigatório informar a Chave PIX. Disponível 24/7.',
    '888': 'TED (CIP): Modalidade específica de TED via Câmara Interbancária de Pagamentos (menos comum que o STR 018).'
  };

  // Carrega originadores quando a matriz muda
  const carregarOriginadores = async (matrizId: string) => {
      if(!matrizId) {
        setOriginadores([]);
        return;
      }
      try {
          // Busca originadores vinculados à matriz selecionada
          const response = await originadorService.listarPorMatriz(matrizId); // Assumindo que existe esse método no service
          setOriginadores(response.data);
      } catch (err) {
          console.error("Erro ao carregar originadores:", err);
          // Não trava a tela se der erro, só loga
      }
  };

  const handleMatrizChange = (e: ChangeEvent<HTMLSelectElement>) => {
      const novaMatriz = e.target.value;
      setMatriz(novaMatriz);
      setOriginador(''); // Limpa originador ao trocar matriz
      if(showOriginadorBox){
          carregarOriginadores(novaMatriz);
      }
  };

  const handleOriginadorChange = (e: ChangeEvent<HTMLSelectElement>) => {
      setOriginador(e.target.value);
  };

  const handleCheckboxOriginador = (e: ChangeEvent<HTMLInputElement>) => {
      const isChecked = e.target.checked;
      setShowOriginadorBox(isChecked);
      if (isChecked && matriz) {
          carregarOriginadores(matriz);
      } else {
          setOriginador('');
          setOriginadores([]);
      }
  }

  const listarPromotoraPorId = async () => {
    try {
      setLoading(true);
      const response = await promotoraService.listarPromotoraPorId(id);
      const jsonPromotora = response.data; 

      setMatriz(jsonPromotora.idMatriz ? jsonPromotora.idMatriz.toString() : '');
      
      // Carrega originadores se tiver matriz
      if (jsonPromotora.idMatriz) {
          await carregarOriginadores(jsonPromotora.idMatriz.toString());
      }

      if (jsonPromotora.idOriginador) {
          setShowOriginadorBox(true);
          setOriginador(jsonPromotora.idOriginador.toString());
      }

      setNome(jsonPromotora.nome);
      setCnpj(jsonPromotora.cnpj);
      setEmails(jsonPromotora.email);
      setRepresentante(jsonPromotora.representante || '');
      setTelefoneComercial(jsonPromotora.foneComercial);
      setTelefoneCelular(jsonPromotora.foneCelular);
      setGerenteResponsavel(jsonPromotora.gerenteResponsavel);
      setValorMeta(jsonPromotora.valorMeta);
      setNumeroMaximoConsultasDia(jsonPromotora.nconsultas ?? 0);
      setCodigoExterno(jsonPromotora.codigoExterno);
      setPromotoraAquisicao(jsonPromotora.promotoraAquisicao ?? false);
      setPromotoraFluxoGestao({
        ...jsonPromotora,
        id: jsonPromotora.id,
        nome: jsonPromotora.nome,
        email: jsonPromotora.email,
        representante: jsonPromotora.representante,
        codigoBanco: jsonPromotora.codigoBanco,
        nomeBanco: jsonPromotora.nomeBanco,
        agencia: jsonPromotora.agencia,
        conta: jsonPromotora.conta,
        statusGestao: jsonPromotora.statusGestao
      });

      // Endereço
      setCep(jsonPromotora.cep || jsonPromotora.enderecoDTO?.cep || '');
      setLogradouro(jsonPromotora.endereco || jsonPromotora.enderecoDTO?.logradouro || '');
      setNumero(jsonPromotora.numeroEndereco || jsonPromotora.enderecoDTO?.numero || '');
      setComplemento(jsonPromotora.complemento || jsonPromotora.enderecoDTO?.complemento || '');
      setBairro(jsonPromotora.bairro || jsonPromotora.enderecoDTO?.bairro || '');
      setLocalidade(jsonPromotora.cidade || jsonPromotora.enderecoDTO?.localidade || '');
      setUf(jsonPromotora.uf || jsonPromotora.enderecoDTO?.uf || '');
      setCodigoExterno(jsonPromotora.codigoExterno);
      setPromotoraAquisicao(jsonPromotora.promotoraAquisicao ?? false);

      // Dados Bancários
      setCodigoBanco(jsonPromotora.codigoBanco || '');
      setNomeBanco(jsonPromotora.nomeBanco || '');
      setAgencia(jsonPromotora.agencia || '');
      setConta(jsonPromotora.conta || '');
      setDigitoConta(jsonPromotora.digitoConta || '');
      setTipoConta(jsonPromotora.tipoConta || 'CORRENTE');
      setCamaraCentralizadora(jsonPromotora.camaraCentralizadora || '018');
      setChavePix(jsonPromotora.chavePix || '');

      if (jsonPromotora.statusGestao === 'PENDENTE_DADOS_COMPLEMENTARES') {
        setPromotoraFluxoGestao(jsonPromotora);
        setDadosGestaoOpen(true);
      }

    } catch (err) {
      console.error(err);
      setAlert({ message: "Erro ao carregar dados da promotora.", type: 'error' });
    }
    setLoading(false);
  };

  const limparCampos = () => {
    setMatriz('');
    setOriginador('');
    setShowOriginadorBox(false);
    setOriginadores([]);
    setNome('');
    setCnpj('');
    setEmails('');
    setRepresentante('');
    setTelefoneComercial('');
    setTelefoneCelular('');
    setGerenteResponsavel('');
    setValorMeta(0);
    setCep('');
    setLogradouro('');
    setNumero('');
    setComplemento('');
    setBairro('');
    setLocalidade('');
    setNumeroMaximoConsultasDia(0);
    setUf('');
    setCodigoExterno('');
    setPromotoraAquisicao(false);
    
    // Limpar Bancários
    setCodigoBanco('');
    setNomeBanco('');
    setAgencia('');
    setConta('');
    setDigitoConta('');
    setTipoConta('CORRENTE');
    setCamaraCentralizadora('018');
    setChavePix('');

    setSelectedRegionais([]); 
    setSelectedComerciais([]);
    setShowRegionalBox(false);
    setShowComercialBox(false);
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault(); 
    
    if (!cnpjValidacao.isValid(cnpj)) {
      setAlert({ message: 'CNPJ inválido', type: 'warning' });
      return;
    } 
    if (!representante.trim()) {
      setAlert({ message: 'Representante obrigatório', type: 'warning' });
      return;
    }
    
    setLoading(true);
    let endereco: EnderecoDTO = new EnderecoDTO();
    endereco.cep = cep;
    endereco.logradouro = logradouro;
    endereco.numero = numero;
    endereco.complemento = complemento;
    endereco.bairro = bairro;
    endereco.uf = uf;
    endereco.localidade = localidade;

    let promotora: PromotoraDTO = new PromotoraDTO();
    promotora.matriz = matriz; // Volta a enviar a Matriz
    promotora.id = id!;
    promotora.nome = nome;
    promotora.cnpj = cnpj;
    promotora.email = emails;
    promotora.representante = representante.trim();
    promotora.enderecoDTO = endereco;
    promotora.telefoneComercial = telefoneComercial;
    promotora.telefoneCelular = telefoneCelular;
    promotora.gerenteResponsavel = gerenteResponsavel;
    promotora.valorMeta = valorMeta;
    promotora.codigoExterno = codigoExterno;
    promotora.nConsultas = numeroMaximoConsultasDia;
    promotora.promotoraAquisicao = promotoraAquisicao;

    // Envia o originador se estiver habilitado e selecionado
    if (showOriginadorBox && originador) {
        promotora.idOriginador = Number(originador);
    } else {
        promotora.idOriginador = null;
    }

    // Preenchendo Dados Bancários
    promotora.codigoBanco = codigoBanco;
    promotora.nomeBanco = nomeBanco;
    promotora.agencia = agencia;
    promotora.conta = conta;
    promotora.digitoConta = digitoConta;
    promotora.tipoConta = tipoConta;
    promotora.camaraCentralizadora = camaraCentralizadora;
    promotora.chavePix = chavePix;

    console.log("Enviando para o backend:", promotora);

    try {
      const response = await promotoraService.incluirAlterarPromotora(promotora);
      setLoading(false);
      const promotoraSalva = response.data;
      if (tipo === 'inclusao' && promotoraSalva?.statusGestao) {
        setPromotoraFluxoGestao(promotoraSalva);
        setDadosGestaoOpen(true);
        return;
      }
      setAlert({ message: 'Promotora salva com sucesso!', type: 'success' });
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: err.response?.data || 'Erro ao salvar promotora.', type: 'error' });
      console.error(err);
    }
  };

  const handleDadosGestaoSalvos = () => {
    const deveAbrirDocumentacao = tipo === 'inclusao'
      && promotoraFluxoGestao?.statusGestao === 'PENDENTE_DADOS_COMPLEMENTARES';
    setPromotoraFluxoGestao((prev) => prev ? {
      ...prev,
      statusGestao: prev.statusGestao === 'PENDENTE_DADOS_COMPLEMENTARES'
        ? 'PENDENTE_DOCUMENTACAO'
        : prev.statusGestao,
      statusGestaoDescricao: prev.statusGestao === 'PENDENTE_DADOS_COMPLEMENTARES'
        ? 'Pendente documentação'
        : prev.statusGestaoDescricao
    } : prev);
    setDadosGestaoOpen(false);
    if (deveAbrirDocumentacao) {
      setDocumentacaoOpen(true);
    } else {
      setAlert({ message: 'Dados complementares salvos com sucesso!', type: 'success' });
    }
  };

  const carregarParametros = async () => {
    try {
      const response = await parametrosService.listarTodosParametros();
      setGestaoPromotoraAtiva(normalizarBooleano(response.data?.gestaoPromotora ?? response.data?.gestao_promotora));
    } catch {
      setGestaoPromotoraAtiva(false);
    }
  };

  const abrirDadosComplementares = () => {
    setPromotoraFluxoGestao((prev) => prev || ({
      id: id ? String(id) : null,
      nome,
      email: emails,
      representante,
      codigoBanco,
      nomeBanco,
      agencia,
      conta
    } as PromotoraDTO));
    setDadosGestaoOpen(true);
  };

  const handleNumeroMaximoConsultasChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const valor = e.target.value.replace(/\D/g, '');
    setNumeroMaximoConsultasDia(valor);
  };

  const viaCep = async (cep: string) => {
    if (cep !== undefined && cep !== '' && cep.length === 10) {
      setLoading(true);
      const cepWithoutMask = cep.replace(/\D/g, '');
      try {
        const response = await viaCepService.viaCep(cepWithoutMask);
        const jsonViaCep = response.data;
        setLogradouro(jsonViaCep.logradouro);
        setLocalidade(jsonViaCep.localidade);
        setUf(jsonViaCep.uf);
        setBairro(jsonViaCep.bairro);
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    const carregarListas = async () => {
      setLoading(true);
      try {
        const matrizRes = await matrizService.listarTodasMatrizesAtivas();

        if (matrizRes.data) {
          setMatrizes(matrizRes.data);
          if (tipo === 'inclusao' && matrizRes.data.length > 0) {
            setMatriz(matrizRes.data[0].id!.toString());
          }
        }
        
      } catch (err) {
        console.error("Erro ao carregar lista de matrizes:", err);
        setAlert({ message: "Erro ao carregar lista de matrizes.", type: 'error' });
      } finally {
        if (tipo !== 'alteracao') {
          setLoading(false);
        }
      }
    };

	    carregarListas();
    carregarParametros();

    if (tipo === 'alteracao' && id) {
      listarPromotoraPorId(); 
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipo, id]);


  return (
    <div className="container">
      {alert && (
        <CustomAlert
          message={alert.message}
          type={alert.type}
          onClose={() => {
            setAlert(null);
            if (alert.type === 'success') {
              window.history.back();
            }
          }}
        />
      )}

      {loading ? (
        <Spinner loading={loading} />
      ) : (
        <form onSubmit={handleSubmit}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
              <h5>
                Origens &gt; Promotora &gt; {tipo === 'inclusao' ? 'Inclusão' : 'Alteração'}
              </h5>
              <div className="d-flex gap-2">
                {gestaoPromotoraAtiva && tipo === 'alteracao' && id && (
                  <Button type="button" variant="outline-secondary" onClick={abrirDadosComplementares}>
                    Dados complementares
                  </Button>
                )}
                <Button id="App-button-cor-principal" onClick={() => window.history.back()}>
                  Voltar
                </Button>
              </div>
            </div>
            <hr className="my-4" />
          </div>

          <div className="row">
            <div className="col-md">
              <label>Matriz <span style={{ color: 'red' }}>*</span></label>
              <select className="form-select" value={matriz} onChange={handleMatrizChange} required>
                {matrizes.map((item) => (
                  <option key={item.id} value={item.id!}>
                    {item.id + ' - ' + item.nome}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md">
              <label>Gerente Responsável</label>
              <input type="text" className="form-control" value={gerenteResponsavel} onChange={(e) => setGerenteResponsavel(e.target.value)} />
            </div>
          </div>

          <hr className="my-4" />
          <h5 className="mb-3">Vínculo {Originador.DESCRITIVO_GERAL}</h5>
          <Row className="mb-3">
            <Col md={12}>
                <Form.Check
                    type="checkbox"
                    id="originadorCheckbox"
                    label={`Vincular a uma ${Originador.DESCRITIVO_GERAL}`}
                    checked={showOriginadorBox}
                    onChange={handleCheckboxOriginador}
                />
            </Col>
          </Row>

          {showOriginadorBox && (
              <Row className="mb-3">
                  <div className="col-md">
                    <label>{Originador.DESCRITIVO_GERAL}</label>
                    <select className="form-select" value={originador} onChange={handleOriginadorChange}>
                        <option value="">Selecione...</option>
                        {originadores.map((item) => (
                        <option key={item.id} value={item.id!}>
                            {item.id + ' - ' + item.nome}
                        </option>
                        ))}
                    </select>
                    {originadores.length === 0 && matriz && (
                        <small className="text-muted">Nenhum originador encontrado para esta Matriz.</small>
                    )}
                  </div>
              </Row>
          )}

          <div className="row mt-3">
            <div className="col-xl">
              <label>Razão Social <span style={{ color: 'red' }}>*</span></label>
              <input required type="text" className="form-control" value={nome} onChange={(e) => setNome(e.target.value)} />
            </div>
            <div className="col-xl">
              <label>CNPJ <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="99.999.999/9999-99" type="text" className="form-control" value={cnpj} onChange={(e) => setCnpj(e.target.value)} />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xl">
              <label>Lista de E-mails (separados por ';')<span style={{ color: 'red' }}>*</span></label>
              <input required type="text" className="form-control" value={emails} onChange={(e) => setEmails(e.target.value)} />
            </div>
            <div className="col-xl">
              <label>Representante <span style={{ color: 'red' }}>*</span></label>
              <input required type="text" className="form-control" value={representante} onChange={(e) => setRepresentante(e.target.value)} />
            </div>
          </div>

          <hr className="my-4" />
          <h5 className="mb-3">Dados Bancários</h5>
          
          <div className="row">
            <div className="col-md-2">
              <label>Cód. Banco <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" placeholder="341" maxLength={3}
                value={codigoBanco} onChange={e => setCodigoBanco(e.target.value)} 
              />
            </div>
            <div className="col-md-4">
              <label>Nome do Banco</label>
              <input type="text" className="form-control" placeholder="Itaú Unibanco" 
                value={nomeBanco} onChange={e => setNomeBanco(e.target.value)} 
              />
            </div>
            <div className="col-md-2">
              <label>Agência (sem dígito) <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" maxLength={5}
                value={agencia} onChange={e => setAgencia(e.target.value)} 
              />
            </div>
            <div className="col-md-3">
              <label>Conta Corrente <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" maxLength={15}
                value={conta} onChange={e => setConta(e.target.value)} 
              />
            </div>
            <div className="col-md-1">
              <label>Dígito</label>
              <input type="text" className="form-control" maxLength={2}
                value={digitoConta} onChange={e => setDigitoConta(e.target.value)} 
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md-2">
              <label>Tipo Conta</label>
              <select className="form-select" value={tipoConta} onChange={e => setTipoConta(e.target.value)}>
                <option value="CORRENTE">Corrente</option>
                <option value="POUPANCA">Poupança</option>
              </select>
            </div>
            <div className="col-md-4">
              <label>Forma de Pagamento <span style={{ color: 'red' }}>*</span></label>
              <select className="form-select" value={camaraCentralizadora} onChange={e => setCamaraCentralizadora(e.target.value)}>
                <option value="018">TED (STR)</option>
                <option value="000">Mesmo Banco (CC)</option>
                <option value="009">PIX</option>
                <option value="888">TED (CIP)</option>
              </select>
            </div>
            {camaraCentralizadora === '009' && (
              <div className="col-md-6">
                <label>Chave PIX <span style={{ color: 'red' }}>*</span></label>
                <input type="text" className="form-control" placeholder="Email, CPF/CNPJ, Celular ou Chave Aleatória"
                  value={chavePix} onChange={e => setChavePix(e.target.value)} 
                  required={camaraCentralizadora === '009'}
                />
              </div>
            )}
          </div>
          
          <div className="row mt-2">
            <div className="col-12">
              <div className="alert alert-info py-2 small mb-0">
                <strong><i className="bi bi-info-circle-fill me-2"></i>Informação:</strong> {explicacoesPagamento[camaraCentralizadora]}
              </div>
            </div>
          </div>

          <hr className="my-4" />


          <div className="row">
            <div className="col-md-2">
              <label>CEP <span style={{ color: 'red' }}>*</span></label>
              <InputMask mask="99.999-999" type="text" className="form-control" required
                value={cep}
                onChange={(e) => setCep(e.target.value)}
                onBlur={(e) => viaCep(e.target.value)}
              />
            </div>
            <div className="col-md">
              <label>Endereço <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={logradouro} onChange={(e) => setLogradouro(e.target.value)} />
            </div>
            <div className="col-md-3">
              <label>Número <span style={{ color: 'red' }}>*</span></label>
              <input type="number" className="form-control" required value={numero} onChange={(e) => setNumero(e.target.value)} />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md">
              <label>Bairro <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={bairro} onChange={(e) => setBairro(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Complemento</label>
              <input type="text" className="form-control" value={complemento} onChange={(e) => setComplemento(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Cidade <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={localidade} onChange={(e) => setLocalidade(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Estado <span style={{ color: 'red' }}>*</span></label>
              <InputMask mask="aa" type="text" required className="form-control" value={uf} onChange={(e) => setUf(e.target.value.toUpperCase())} />
            </div>
          </div>

          <hr className="my-4" />

          <div className="row">
            <div className="col-md">
              <label>Telefone Comercial <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="(99)9999-9999" type="text" className="form-control" value={telefoneComercial} onChange={(e) => setTelefoneComercial(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Telefone Celular <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="(99)99999-9999" type="text" className="form-control" value={telefoneCelular} onChange={(e) => setTelefoneCelular(e.target.value)} />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md">
              <label>Valor Meta <span style={{ color: 'red' }}>*</span></label>
              <NumericFormat
                className="form-control"
                required
                thousandSeparator="."
                decimalSeparator=","
                prefix="R$ "
                value={valorMeta}
                onValueChange={(values) => setValorMeta(values.value)}
              />
            </div>

            <div className="col-md">
              <label>Número Máximo de Consultas Margem por Dia <span style={{ color: 'red' }}>*</span></label>
              <input type="number" required className="form-control" value={numeroMaximoConsultasDia} onChange={handleNumeroMaximoConsultasChange} />
            </div>
          </div>

          <hr className="my-4" />
          
          <div className="row">
            <div className="col-md">
              <label>Código Externo</label>
              <input type="text" className="form-control" value={codigoExterno} onChange={(e) => setCodigoExterno(e.target.value)} />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="promotoraAquisicao"
                  checked={promotoraAquisicao}
                  onChange={(e) => setPromotoraAquisicao(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="promotoraAquisicao">
                  Promotora Aquisição
                </label>
              </div>
            </div>
          </div>

          <hr className="my-4" />

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <button onClick={limparCampos} className="w-40 btn btn-lg" id="App-button-cor-principal" type="button">Limpar Campos</button>
            <button className="w-40 btn btn-success btn-lg" type="submit">
              {tipo !== 'inclusao' ? 'Alterar Promotora' : 'Salvar Promotora'}
            </button>
          </div>
        </form>
      )}
      <PromotoraDadosGestaoModal
        show={dadosGestaoOpen}
        promotora={promotoraFluxoGestao}
        obrigatorio={tipo === 'inclusao' && promotoraFluxoGestao?.statusGestao === 'PENDENTE_DADOS_COMPLEMENTARES'}
        onHide={() => setDadosGestaoOpen(false)}
        onSaved={handleDadosGestaoSalvos}
      />

      <PromotoraDocumentacaoModal
        show={documentacaoOpen}
        promotora={promotoraFluxoGestao}
        onHide={() => {
          setDocumentacaoOpen(false);
          window.history.back();
        }}
        onUpdated={() => undefined}
      />
    </div>
  );
}

export default PromotoraInclusaoAlteracao;
